import { sendFingerprintToBackend } from '@/utils/fingerprint';
import { setFingerprintCaptured } from '@/utils/fingerprintStorage';

export type Props = {
  visitorId: string | null;
};

export const persistDeviceFingerprint = ({ visitorId }: Props): void => {
  setFingerprintCaptured();

  if (visitorId) {
    sendFingerprintToBackend(visitorId).catch((error) => {
      console.warn('Failed to send fingerprint for session tracking:', error);
    });
  }
};
